import { render, staticRenderFns } from "./PFSignupFront.vue?vue&type=template&id=597ac957"
import script from "./PFSignupFront.vue?vue&type=script&lang=js"
export * from "./PFSignupFront.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports